import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import CmsPageComponentSelector from '@/cms/components/infrastructure/pageComponentSelector/PageComponentSelector.vue';
import store from '@/store/store';
import { UPDATE_MODEL_BY_URL } from '@/store/modules/epiContent';
import { isApp, AppSendMessage } from './views/calculators/services/environmentService';

const appCallbackPath = (to, from, next) => {
	// DEBUG console.log('appCallbackPath', to, from, next);
	if (isApp()) {
		if (store.getters.getAppReplaceRoute) {
			AppSendMessage({ REPLACE_ROUTE_PATH: to.path });
			store.dispatch('setAppReplaceRoute', false);
		} else {
			AppSendMessage({ ROUTE_PATH: to.path });
		}
	}
	next();
};

const routes: Array<RouteRecordRaw> = [
	{
		name: 'page-component-selector',
		path: '/:pathMatch(.*)',
		component: CmsPageComponentSelector,
		beforeEnter: appCallbackPath,
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
	linkActiveClass: 'active-child',
	linkExactActiveClass: 'active',
});

router.beforeEach((to, from) => {
	store.state.toUrl = to;
	store.state.fromUrl = from;
});

router.beforeEach(async (to, from, next) => {
	// URL is updated by vue-route-sync, and when time traveling with the
	// we don't want to trigger a model commit as the model is already
	// part of the store holding the url update.
	const currentModelUrl = store.state.epiContent.model?.canonicalUrl.path;
	await updateModelByUrlFromFullPath(to, next, currentModelUrl);
});

async function updateModelByUrlFromFullPath(to, next, currentModelUrl) {
	const fullPath = to.fullPath.replace('#', ''); // klk # anchors should never be in Url's
	if (currentModelUrl !== fullPath) {
		await store.dispatch(UPDATE_MODEL_BY_URL, fullPath);
		//dont render next page before model has been updated from url
	}
	next();
}

export default router;
